// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/en'
import VueI18n from 'vue-i18n'
import messages from '../common/lang.js'
import VueAwesomeSwiper from 'vue-awesome-swiper'
// import 'swiper/swiper-bundle.css'
import 'swiper/css/swiper.css'

axios.defaults.baseURL = '/' // 上服务器
// axios.defaults.baseURL = '/hosturl' // 本地
axios.defaults.timeout = 10000;

// 拦截请求
axios.interceptors.request.use(function(config) {
  //在发送请求之前做某件事
	return config;
}, function(error) {
  // 对请求错误做些什么
  return Promise.reject(error);
})

// 拦截响应
axios.interceptors.response.use(function(response) {
  // 处理响应数
  if (response.status === 200) {
    return Promise.resolve(response);
  } else {
    return Promise.reject(response);
  }
}, function(error) {
  // 处理响应失败
  return Promise.reject(error);
});
Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI,{locale});
Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: 'zh',
  silentTranslationWarn: true,
  messages
})
Vue.prototype._i18n = i18n
Vue.prototype.axios = axios;
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  components: {
    i18n,
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js